import React, { useState } from "react";
import uuid from "react-native-uuid";
import ReactDOM from "react-dom";
import AddCommand from "../Commands/AddCommand/AddCommand";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import MenuDots from "../MenuDots/MenuDots";
import useValidationInput from "../../Hooks/useValidationInput.js";
//import useGetCurrentsTools from "../../Hooks/useGetCurrentsTools.js";
import useSetDataVariableInText from "../../Hooks/useSetDataVariableInText.js";
import useGetValueFromArray from "../../Hooks/useGetValueFromArray.js";
import Autocomplete from "../Autocomplete/Autocomplete";
import RadioIcon from "../Commands/RadioIcon/RadioIcon";
import EditableDropDownList from "../EditableDropDownList/EditableDropDownList";
import MiddleEditCommand from "../Commands/MiddleEditCommand/MiddleEditCommand";
import ShowCommand from "../Commands/ShowCommand/ShowCommand";
import HideCommand from "../Commands/HideCommand/HideCommand";
import DropDownListNew from "../DropDownList/DropDownListNew";
import TreeViewDialog from "../TreeViewDialog/TreeViewDialog";
import "./SimpleModal.css";
import SendCommand from "../Commands/SendCommand/SendCommand";
import useApiOperation from "../../Hooks/useApiOperation.js";
import useGetResponseData from "../../Hooks/useGetResponseData.js";
import Tree from "../Tree/Tree";
import RichTextEditor from "../Commands/RichTextEditor/RichTextEditor";


export default function SimpleModal (props)  {
  
  const [settings, setSetting] = useState(props.settings);
  const isPropertiesText = settings.type.toLowerCase() == "properties" && settings.menu ==  "text"
  

  const getCurrentSettings  = ()  => 
  { 
    const controlDataOptions = props.settings.controlDataOptions
    const defaulOptions = props.formData.lists.validations[settings.type.toLowerCase()][settings.menu]
    
    return controlDataOptions ? {...defaulOptions, options:controlDataOptions } : defaulOptions
    
   
  }
  
  const currentSetting = getCurrentSettings();
  const apiSettings = props.formData.lists.validations.events.api;
  var sample = {id:0, item:"", value:"", details:[] }
  var apiSample = {id:0, item:"", value:"", method: "GET", option:props.formData.actions.api.params , Params : {details:[]} }
  var conditionItem = {id:0, option:"", firstOperand:{id:"", value:"",  isClick:false}, operator:{value:"="}, secondOperand:{id:"",value:"",isClick:false} }
  var apiSettingItem = {id:0, option:"",  key:{id:"", value:"", isClick:false}, value:{id:"", value:"", isClick:false}, destination:{value:"Auth"} }
  var listSettingItem = {id:0, option:"",  key:{id:"", value:"", isClick:false}, value:{id:"", value:"", isClick:false} }
  var treeItem = {id:0, item:"",  key:{id:"", value:"", isClick:false}, value:{id:"", value:"", isClick:false}, childs:[] }
  const menuList = {
    width: "100px",
    list: [
      {
        id: 1,
        item: "Add Child",
        action: { type: "AddChild", icon: "Add" },
      },
      {
        id: 2,
        item: "Delete Child",
        action: { type: "DeleteChild", icon: "Delete" },
      }
    ],
  }
 
  
  const isInputValid = useValidationInput();
  const callApi = useApiOperation(apiSettings.options);
  const getResponseData = useGetResponseData();
  const rawFildId = "10"
  const rawEditorId = "Editor" + rawFildId
  const setDataVariableInText = useSetDataVariableInText();
  const getValueFromArray = useGetValueFromArray();

  const getCurrentConditions = (current = settings)  => 
  {
    return current.conditions.values ? current.conditions.values.filter(item => item.id == current.conditions.id)[0] : {details:[]}
  };

  const getCurrentApi = (current = settings)  => 
  {
    return current.api.values ? current.api.values.filter(item => item.id == current.api.id)[0] 
    : {}
  };

  const getCurrentOption = (type, current = settings)  => 
  {
    return current.data[type].values ? current.data[type].values.filter(item => item.id == current.data[type].id)[0] : {details:[]}
  };

  
  const changeValue = (value, fieldId ,fieldName="value", detail = undefined) => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    
    if (detail) {
      if(isApiDetailsSettings(detail.type))
        getCurrentApi(settingsData)[getCurrentApi(settingsData).option].details.filter(item => item.id == detail.id)[0][detail.type].value = value;

      else if(isApiBodyDetailsSettings(detail.type)){
        getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].details.filter(item => item.id == detail.id)[0][detail.type].value = value;
      }
      else if(isConditionsDetailsSettings(detail.type))
        getCurrentConditions(settingsData).details.filter(item => item.id == detail.id)[0][detail.type].value = value;

      else if(isListDetailsSettings(detail.type))
        getCurrentOption("list", settingsData).details.filter(item => item.id == detail.id)[0][detail.type].value = value;
      
      else if(isMappingDetailsSettings(detail.type))
        getCurrentOption("mapping", settingsData).details.filter(item => item.id == detail.id)[0][detail.type].value = value;

      else if(isTreeDetailsSettings(detail.type))
        getNode(getCurrentOption("tree", settingsData).details, detail.id)[0][detail.type].value = value;


    }
    else {
      if(isApiActif()){     
        getCurrentApi(settingsData)[fieldName] = value;
        getCurrentApi(settingsData)["fieldId"] = fieldId
      } 
      else if (isConditionsActif()) {
        settingsData.conditions.value = "Conditions value";
        settingsData.conditions["fieldId"] = fieldId
        getCurrentConditions(settingsData)["value"] = value;
      } 
      else if (isListActif()) {
        settingsData.list.value = "Lists value";
        settingsData.list["fieldId"] = fieldId
        getCurrentOption("list", settingsData)["value"] = value;
      } 
      else if (isMappingActif()) {
        settingsData.data.mapping.value = "Mapping value";
        settingsData.data.mapping["fieldId"] = fieldId
        getCurrentOption("mapping", settingsData).data["value"] = value;
      }
      else if (isTreeActif()) {
        settingsData.mapping.value = "Tree value";
        settingsData.mapping["fieldId"] = fieldId
        getCurrentOption("tree", settingsData)["value"] = value;
      }
      else if (isTextActif()) {
        settingsData.text.value = value;
        settingsData.conditions["fieldId"] = fieldId
      }
      
    }
    setSetting(settingsData)
  };


 
 const getEvents = (event) => { 
    return currentSetting[event]
 }

const replaceValue = (value, replaces) => {
  if( replaces )
    replaces.map(replace => value = value.replace(replace.old, replace.new)) 
  return value
}

const getTreeComponent = (data, id) => {
  
  return <div id={id} key={id} style ={{ border:"1px solid lightGray", marginTop: "4px", overflow: "auto"}}>
          <Tree 
            showToolbar = {true} 
            onCheckedItem = {(checkeds, dataLabel, menuPaths) =>  {}}
            withCheckBox = {false} 
            menuItems = {data}/>
        </div>
}
const getTitle = () => {
  var replaces = currentSetting.replacesValues
  var currentType =  props.formData.menu.operation.Update
  var menuError = " "
  if (onError) {
    const currentOption = isApiActif() ? getCurrentApi().option : settings.option
    const currentError = settings.errors.filter(error => error.option == currentOption).slice(-1)[0]
    if (currentError) {
      currentType = currentError.type 
      replaces = currentError.replacesValues
    } else {
      const defaultError = settings.errors.slice(-1)[0]
      currentType = defaultError.type 
      replaces = defaultError.replacesValues
      
      menuError = isApiBodySubOption(defaultError.option) ?  
                    (isApiActif() && isApiBodyActif() && defaultError.option == getCurrentApi()[props.formData.actions.api.body].option ? "" : " ( Api --> Body --> " + defaultError.option + " )")  //" ( " : " ( Api --> Body --> ") + defaultError.option + " )" 
                    : isApiSubOption(defaultError.option) ? 
                    (isApiActif() ? " ( " : " ( Api --> ") + defaultError.option + " )" :  " ( " + defaultError.option + " )"
    } 
    
  } 

  
  
  return props.formData.log.filter(
    log => log.type == currentType
  ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces) + menuError}</span>})[0]
}

const fireEventKeyPress = (e, detail, event) => {
  const typeEvents = getEvents(event)
  var settingsData = JSON.parse(JSON.stringify(settings));
  settingsData.errors = settingsData.errors.filter(error => error.id != detail.id )
  
  
  if(!isInputValid({value: e.key}, typeEvents).isValid) {
    e.preventDefault()
  }
  setSetting(settingsData)
}

const fireEventKeyPressByMenu = (e, detail, event) => {
  const typeEvents = props.formData.menu[detail.type].validations[event]
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  settingsData.errors = settingsData.errors.filter(error => error.id != detail.id )

  if(!isInputValid({value: e.key}, typeEvents).isValid) {
    e.preventDefault()
  }
  setSetting(settingsData);
}


const fireEventByMenuAndConditionAndSetValue = (e, detail, event) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  const typeEvents = props.formData.menu[detail.type].validations ? props.formData.menu[detail.type].validations[event] : []
  const eventResponse = isInputValid({value: e.target.value}, typeEvents);
  
  if(eventResponse.isValid) {
    settingsData.errors = settingsData.errors.filter(error => !(error.id == detail.id && error.event == event) )
  }
  else {
    settingsData.errors.push({id:detail.id
      , option: isApiActif() && isApiBodyActif() ? getCurrentApi()[props.formData.actions.api.body].option :
                  isApiActif() ? getCurrentApi().option : settings.option
      , event:event, type:eventResponse.type, replacesValues: props.formData.menu[detail.type].replacesValues})
  }
 
  setSetting(settingsData);
}

const getNodeTypes = (nodes, keys, type) => {
  nodes.map(node => {
    keys.push(node[type])
    getNodeTypes(node.childs, keys, type)
  })
}

const fireEventOnSaveValue = (event = "onBlur") => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  
  var typeEvents = [] //currentSetting[event]
  
  switch (settingsData.option) {
    case props.formData.actions.option.text: {  
      const settingsToValidate = settingsData[settingsData.option.toLowerCase()] 
      typeEvents = currentSetting[event]
      let eventResponse = isInputValid({value: settingsToValidate.value}, typeEvents);
      if(!eventResponse.isValid) 
        settingsData.errors.push({id:settingsToValidate.fieldId, option: settings.option, event:event, type:eventResponse.type
          , replacesValues: currentSetting.replacesValues})
       
      break;
    }
    case props.formData.actions.option.condition: {
      const settingsToValidate = settingsData[settingsData.option.toLowerCase()]
      let detailsToValidate = settingsToValidate.values ? settingsToValidate.values.map(value => value.details).flat(Infinity): []
      let firstOperandData = detailsToValidate.map(detail => detail.firstOperand)
      let firstOperandEvents = props.formData.menu[props.formData.actions.condition.type.firstOperand].validations[event]
      firstOperandData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value}, firstOperandEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.condition.type.firstOperand].replacesValues})
        }
      )

      let secondOperandData = detailsToValidate.map(detail => detail.secondOperand)
      let secondOperandEvents = props.formData.menu[props.formData.actions.condition.type.secondOperand].validations[event]
      secondOperandData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value}, secondOperandEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.condition.type.secondOperand].replacesValues})
        }
      )
      break;
    }
    case props.formData.actions.option.list:
    case props.formData.actions.option.mapping: {
      
      const settingsToValidate = settingsData.data[settingsData.option.toLowerCase()]
      let detailsToValidate = settingsToValidate.values ? settingsToValidate.values.map(value => value.details).flat(Infinity) : []
      let keyData = detailsToValidate.map(detail => detail.key)
      let keyEvents = props.formData.menu[props.formData.actions.api.type.key].validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.api.type.key].replacesValues})
        }
      )

      let valueData = detailsToValidate.map(detail => detail.value)
      let valueEvents = props.formData.menu[props.formData.actions.api.type.value].validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.api.type.value].replacesValues})
        }
      )
      break;
    }

    case props.formData.actions.option.tree: {
      
      const settingsToValidate = settingsData.data[settingsData.option.toLowerCase()]
      let detailsToValidate = []

      if (settingsToValidate.values) {
        var keyData = []
        getNodeTypes(settingsToValidate.values.map(item => item.details).flat(Infinity), keyData, "key")
        let keyEvents = props.formData.menu[props.formData.actions.api.type.key].validations[event]
        keyData.map(itemData => {
          let eventResponse = isInputValid({value: itemData.value}, keyEvents);
          if(!eventResponse.isValid) 
            settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
              , replacesValues: props.formData.menu[props.formData.actions.api.type.key].replacesValues})
          } 
        )

        var valueData = []
        getNodeTypes(settingsToValidate.values.map(item => item.details).flat(Infinity), valueData, "value")
        let valueEvents = props.formData.menu[props.formData.actions.api.type.value].validations[event]
        valueData.map(itemData => {
          let eventResponse = isInputValid({value: itemData.value}, valueEvents);
          if(!eventResponse.isValid) 
            settingsData.errors.push({id:itemData.id, option: settings.option, event:event, type:eventResponse.type
              , replacesValues: props.formData.menu[props.formData.actions.api.type.value].replacesValues})
          }
        )

      }

     
      break;
    }
    
      
    case props.formData.actions.option.api: {
      let detailsToValidate = []
      let rawToValidate = {}
      const settingsToValidate = getCurrentApi(settingsData) 
      apiSettings.options.map(option =>
        settingsToValidate[option] && settingsToValidate[option].details 
        && settingsToValidate[option].details.length > 0 && detailsToValidate.push(settingsToValidate[option].details)
      )
      const settingsBodyToValidate = getCurrentApi(settingsData)[props.formData.actions.api.body]
      if (settingsBodyToValidate)
        apiSettings.body.options.map(option => {
          let optionName = option.replaceAll("-", "")          
          if (settingsBodyToValidate[optionName])
            if (settingsBodyToValidate[optionName].details )
              settingsBodyToValidate[optionName].details.length > 0 && detailsToValidate.push(settingsBodyToValidate[optionName].details)
            else if(settingsBodyToValidate[optionName].format)
              rawToValidate ={type:settingsBodyToValidate.type
                , textContent:settingsBodyToValidate[optionName].value
                , checkedDetail: settingsBodyToValidate[optionName].checkedDetail}
        })
      
      
      if (rawToValidate.type && rawToValidate.type != props.formData.actions.option.text) {
        
        let data = rawToValidate.checkedDetail ? setDataVariableInText(rawToValidate.textContent, rawToValidate.checkedDetail) : rawToValidate.textContent;
        
        let eventResponse = isInputValid({value:{ data:data}}, [{ type:rawToValidate.type}]);
        
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:settingsBodyToValidate[props.formData.actions.api.raw].fieldId
          , option: props.formData.actions.api.raw, event:event, type:eventResponse.type, replacesValues: []})
      }
           
      detailsToValidate = detailsToValidate.flat(Infinity)
      /*let options = detailsToValidate.map(item => item.option)
      let details = detailsToValidate.map(item => item.details).flat(Infinity)
      detailsToValidate = details.map((detail, index) => {return {option:options[index], key:detail.key, value:detail.value }})
      */
      
      let keyData = detailsToValidate.map(detail =>{return {option:detail.option, key:detail.key }})
      let keyEvents = props.formData.menu[props.formData.actions.api.type.key].validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.key.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.key.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.api.type.key].replacesValues})
        }
      )
      let valueData = detailsToValidate.map(detail => {return {option:detail.option, value:detail.value }})
      let valueEvents = props.formData.menu[props.formData.actions.api.type.value].validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.value.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: props.formData.menu[props.formData.actions.api.type.value].replacesValues})
        }
      )
      break;
    }
      

  }
 
  
  if (settingsData.errors.length == 0) {
    if (getCurrentApi(settingsData) && getCurrentApi(settingsData)[props.formData.actions.api.response]) {
      getCurrentApi(settingsData)[props.formData.actions.api.response][props.formData.actions.api.content] = {value: []}
      getCurrentApi(settingsData)[props.formData.actions.api.response][props.formData.actions.api.cookies] = {value: []}
    }
    props.onValidChange(settingsData)
    //props.onValidChange(settings)

  }
  
  setSetting(settingsData);
}

const fireOtherEvent = (e, detail, event) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  const typeEvents = getEvents(event)
  
  const eventResponse = isInputValid({value: e.target.value, values:props.columnsNames}, typeEvents);
  if(eventResponse.isValid) {
    settingsData.errors = settingsData.errors.filter(error => !(error.id == detail.id && error.event == event) )
  }
  else {
    settingsData.errors.push({id:detail.id, option: isApiActif() ? getCurrentApi().option : settings.option
      , event:event , type:eventResponse.type, replacesValues: currentSetting.replacesValues})
    
  }

  
  setSetting(settingsData)
 
}


const getOptionForm = (value) => {
  
  switch (value) {
    case props.formData.actions.option.text:  
      return getTextOption(props.formData.actions.option.text, settings.text.value)
    case props.formData.actions.option.condition:
      return getConditionOption()
    case props.formData.actions.option.api:
      return getApiOption()
    case props.formData.actions.option.list:
      return getOption("list")
    case props.formData.actions.option.mapping:
      return getOption("mapping")
    case props.formData.actions.option.tree:
      return getTreeOption("tree")
   
  }
}

const onClickSend = (e) => { 
  
  e.preventDefault(); 
  const responsePromise = callApi(getCurrentApi())
  responsePromise.then(response => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentApi = getCurrentApi(settingsData)
    const schemaGlobalId = uuid.v4()
    const data = getResponseData(response, schemaGlobalId)
    //const data = getResponseData(response, currentApi.id)
    
    currentApi.option = props.formData.actions.api.response
    currentApi[props.formData.actions.api.response] = {option :props.formData.actions.api.content}
    currentApi[props.formData.actions.api.schemas] = {option :props.formData.actions.api.content}

    currentApi[props.formData.actions.api.response][props.formData.actions.api.content] = {value: data.treeData}
    currentApi[props.formData.actions.api.response][props.formData.actions.api.cookies] = {value: []}
    currentApi[props.formData.actions.api.schemas][props.formData.actions.api.content] = {globalId:schemaGlobalId, value: data.schemaData}
    currentApi[props.formData.actions.api.schemas][props.formData.actions.api.cookies] = {value: []}

    
    
    setSetting(settingsData)
  })
 }
/*
const onClickSend = (e) => { 
  e.preventDefault(); 
  const responsePromise = callApi(getCurrentApi())
  responsePromise.then(response => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentApi = getCurrentApi(settingsData)

    const data = getTreeViewData(response, currentApi.id)
    
    currentApi.option = props.formData.actions.api.response
    currentApi[props.formData.actions.api.response] = {option :props.formData.actions.api.content}
    currentApi[props.formData.actions.api.schemas] = {option :props.formData.actions.api.content}

    currentApi[props.formData.actions.api.response][props.formData.actions.api.content] = {value: data.treeData}
    currentApi[props.formData.actions.api.response][props.formData.actions.api.cookies] = {value: []}
    currentApi[props.formData.actions.api.schemas][props.formData.actions.api.content] = {globalId:uuid.v4(), value: data.schemaData}
    currentApi[props.formData.actions.api.schemas][props.formData.actions.api.cookies] = {value: []}

    
    
    setSetting(settingsData)
  })
}*/

 

const getApiUrl = (width = "100%") => {
  const fieldId = settings.option + "UrlValue"
  return <div id={settings.option + "UrlValue"} style={{  display: "flex", marginRight: "5px"}} >
          <input
            className="textBoxWithoutBorder"
            value={getCurrentApi().value? getCurrentApi().value : ""}
            onKeyPress={(e) => fireEventKeyPress(e, {id : fieldId},props.formData.actions.event.type.onkeyPress) }
            onBlur={(e) => fireOtherEvent(e, {id : fieldId},props.formData.actions.event.type.onBlur) }
            onChange={(e) => changeValue(e.target.value, fieldId) }
            style={{width: width, marginLeft: "5px"}}/>
          {<div onClick = {(e) => onClickSend(e)}>
            <SendCommand className ="hoverBlue"/>
          </div>}
        </div>
}



const getDetailValue = (id, type, parents = undefined) => {
  const currentItem = isConditionsActif () ? getCurrentConditions().details.filter(item => item.id == id) :
    isListActif() ? getCurrentOption("list").details.filter(item => item.id == id) :
    isMappingActif() ? getCurrentOption("mapping").details.filter(item => item.id == id) :
    isTreeActif() ? getNode(getCurrentOption("tree").details, id)
    : undefined
  ;
    if (currentItem) {
    const value = currentItem[0][type].value
    const isRelationData = Array.isArray(value)
    if (isRelationData) {
      
      return getValueFromArray(value, undefined,parents ).name
    }
    else
      return value
  }
  else
    return ""
}



const getDetailApiSettingValue = (id, type, isSubBody = false) => {
  var currentApiSetting = isSubBody ? getCurrentApi()[props.formData.actions.api.body][getBodyOptionValue()]
  : getCurrentApi()[getCurrentApi().option]
  currentApiSetting = currentApiSetting.details.filter(item => item.id == id);
  if (currentApiSetting) {
    const value = currentApiSetting[0][type].value
    const isRelationData = Array.isArray(value)
    if (isRelationData) {

      return getValueFromArray(value).name
    }
    else
      return value
  }
  else
    return ""
}


const onSaveSelection = (e, selectedsItems, fieldId, detail = undefined) => {
  e.preventDefault();
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  settingsData.errors = settingsData.errors.filter(error => error.id != fieldId )  
  if (isConditionsActif()) { //
    var currentCondition = getCurrentConditions(settingsData)
    if (detail && isConditionsDetailsSettings(detail.type)) {
      //settingsData.conditions["dataLabels"] = selectedsItems.dataLabels
      currentCondition.details.filter(item => item.id == detail.id)
      .map(item => {
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].isClick = false;  
      } )
    }
    else {
      if (currentCondition.details)
        getCurrentConditions(settingsData).value = selectedsItems.checkeds;
      else  
        settingsData.conditions.value = selectedsItems.checkeds;
      settingsData.conditions.isClick = false;
    }
  }

  if (isListActif()) { //
    var currentList = getCurrentOption("list", settingsData)
    if (detail && isListDetailsSettings(detail.type)) {
      currentList.details.filter(item => item.id == detail.id)
      .map(item => {
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].isClick = false;  
      } )
    }
    else {
      if (currentList.details)
        getCurrentOption("list",settingsData).value = selectedsItems.checkeds;
      else  
        settingsData.list.value = selectedsItems.checkeds;
      settingsData.list.isClick = false;
    }
  }

  if (isMappingActif()) { //
    var currentList = getCurrentOption("mapping", settingsData)
    if (detail && isMappingDetailsSettings(detail.type)) {
      currentList.details.filter(item => item.id == detail.id)
      .map(item => {
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].isClick = false;  
      } )
    }
    else {
      if (currentList.details)
        getCurrentOption("mapping",settingsData).value = selectedsItems.checkeds;
      else  
        settingsData.data.mapping.value = selectedsItems.checkeds;
      settingsData.data.mapping.isClick = false;
    }
  }
  
  if (isTreeActif()) { //
    var currentTree = getCurrentOption("tree", settingsData)
    if (detail && isTreeDetailsSettings(detail.type)) {
      getNode(currentTree.details, detail.id)
      .map(item => {
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].isClick = false;  
      } )
    }
    else {
      if (currentTree.details)
        getCurrentOption("tree",settingsData).value = selectedsItems.checkeds;
      else  
        settingsData.tree.value = selectedsItems.checkeds;
      settingsData.tree.isClick = false;
    }
  }
  
  if (isApiActif()) { //
    
    if(!detail) return
    
    if (isApiDetailsSettings(detail.type)) {
      
      getCurrentApi(settingsData)[getCurrentApi(settingsData).option]["dataLabels"] = selectedsItems.dataLabels
      getCurrentApi(settingsData)[getCurrentApi(settingsData).option].details.filter(item => item.id == detail.id)
      .map(item => {
        
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].isClick = false;  
      } )
    }
  }

  if (isTextActif()) {
    settingsData.text.value = selectedsItems.checkeds;
    settingsData.text.isClick = false;
  }
  
  setSetting(settingsData)
}

const isApiBodyDetailsSettings = (type) => {
  
  return isApiActif() && isApiBodyActif() && (type == props.formData.actions.api.type.key 
  || type == props.formData.actions.api.type.value)
}

const isApiDetailsSettings = (type) => {
  return isApiActif() && !isApiBodyActif() && (type == props.formData.actions.api.type.key 
  || type == props.formData.actions.api.type.value)
}

const isConditionsDetailsSettings = (type) => {
  return isConditionsActif() && (type == props.formData.actions.condition.type.firstOperand 
  || type == props.formData.actions.condition.type.secondOperand)
}

const isListDetailsSettings = (type) => {
  return isListActif() && (type == props.formData.actions.api.type.key 
  || type == props.formData.actions.api.type.value )
}

const isMappingDetailsSettings = (type) => {
  return isMappingActif() && (type == props.formData.actions.api.type.key 
  || type == props.formData.actions.api.type.value )
}

const isTreeDetailsSettings = (type) => {
  return isTreeActif() && (type == props.formData.actions.api.type.key 
  || type == props.formData.actions.api.type.value )
}

const isKeyColonne = (type) => {
  
  return type == props.formData.actions.api.type.key
}

const isValueColonne = (type) => {
  
  return type == props.formData.actions.api.type.value
}

const isClickOnHide = (isHide) => {
  
  return isHide[props.formData.actions.api.type.key].isClick
}

const getCommandIcon = (type, isHide) => {
  return isKeyColonne(type) && !isMappingActif() ? (isListActif() || isTreeActif() ? null : (isHide ? <HideCommand />  : <ShowCommand /> ))
          :  <MiddleEditCommand className ="hoverBlue"/>
}

const getTypeInput = (type, item) => {
  return isValueColonne(type) && isClickOnHide(item) ? "password" : "text"
}

const isInError = (id)=> {
   
  return settings.errors.filter(error => error.id == id).length > 0
}

const getAutoCompletion =(item, type, fieldId, placeHolder) => {
  
  return <div style={{  height: "20px" }}>
    <Autocomplete 
      id={fieldId} //id={"Autocomplete" + fieldId}
      placeholder={placeHolder}
      type = {getTypeInput(type, item)}
      onLyBottom= {true} 
      style={{ width:"246px", height:"20px", fontFamily: "Arial", fontSize: "12px", 
      border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}
      containerStyle={{width:"245px"}}
      emphasised= {false}
      value={isApiDetailsSettings(type) ? getDetailApiSettingValue(item.id, type) : getDetailValue(item.id, type)}
      data = {props.formData.lists.validations.events.api.headers[type]}
      onKeyPress={(e) => fireEventKeyPressByMenu(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onkeyPress) }
      onBlur={(e) => fireEventByMenuAndConditionAndSetValue(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onBlur) }
      onChange={(e, value) => changeValue(value, fieldId, "value", {id:item.id, type:type  }) }
      onSelectedItem={(e, itemSelected) => changeValue(itemSelected.item, fieldId, "value", {id:item.id, type:type  })}/>
    </div>

}

const getInput =(item, type, fieldId, placeHolder, option) => {
  return  <input
    className="textBoxWithoutBorder"
    type = {getTypeInput(type, item)}
    readOnly= {(isMappingActif() && isKeyColonne(type)) || (isTreeActif() && isValueColonne())}
    placeholder = {placeHolder}
    value={isApiDetailsSettings(type) ? getDetailApiSettingValue(item.id, type) 
      : getDetailValue(item.id, type, option.parents)}
    onKeyPress={(e) => fireEventKeyPressByMenu(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onkeyPress) }
    onBlur={(e) => fireEventByMenuAndConditionAndSetValue(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onBlur) }
    onChange={(e) => changeValue(e.target.value, fieldId, "value",{id:item.id, type:type  }) }
    style={{width: option.width, fontSize: "12px",fontFamily: "Arial", paddingTop: "3px"
    , border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}/>

}

const getSubBodyInput =(item, type, fieldId, placeHolder, width) => {
  return  <input
    className="textBoxWithoutBorder"
    type = {getTypeInput(type, item)}
    placeholder = {placeHolder}
    value={getDetailApiSettingValue(item.id, type, true)}
    onKeyPress={(e) => fireEventKeyPressByMenu(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onkeyPress) }
    onBlur={(e) => fireEventByMenuAndConditionAndSetValue(e, {id:fieldId, type:type  }, props.formData.actions.event.type.onBlur) }
    onChange={(e) => changeValue(e.target.value, fieldId, "value",{id:item.id, type:type  }) }
    style={{width: width, fontSize: "12px",fontFamily: "Arial", paddingTop: "3px"
    , border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}/>

}

const isHeaders = (type) => {
  return isApiDetailsSettings(type) && getCurrentApi().option == props.formData.actions.api.headers
}

const getTextRelation = (item, type, fieldId, placeHolder, 
  option ={width : "220px", typeData : settings.data && settings.data[settings.option.toLowerCase()].treeDataType
  }) => {
  
  return <div id ={fieldId} style={{  display: "flex", marginRight: "5px"}} >
          {isHeaders(type) ? getAutoCompletion(item, type, fieldId, placeHolder) :  getInput(item, type, fieldId, placeHolder, option)}
          {<div onClick={(e) => onClickEditOperand(item, type, e) } >
            {getCommandIcon(type, item[type].isClick)}
          </div>}
          { item[type].isClick && (isMappingActif() ||  !isKeyColonne(type)) && <TreeViewDialog  
              onSaveSelection = {(e, selectedsItems) =>  onSaveSelection(e, selectedsItems, fieldId, {id:item.id, type:type  })}
              onClose = {() => onClickEditOperand(item, type)} 
              withCheckBox = {true}
              leafSelection = {true}
              data = {props.formData}
              previousForms = {props.previousForms}

              ancestorId = {option.ancestorId}
              customData = {option.customData} //{props.formData}
              title = {option.customTitle}
              typeData = {option.typeData}
              //typeData = {settings.data && settings.data[settings.option.toLowerCase()].treeDataType}
              parentId = {fieldId} type = {props.formData.menu.type.field} />}
          
      </div>
}

const getBodyTextRelation = (item, type, fieldId, placeHolder, width = "220px") => {
   
  return <div id ={fieldId} style={{  display: "flex", marginRight: "5px"}} >
          {getSubBodyInput(item, type, fieldId, placeHolder, width)}
          {<div onClick={(e) => onClickEditOperand(item, type, e) } >
            {getCommandIcon(type, item[type].isClick)}
          </div>}
          {item[type].isClick && !isKeyColonne(type) && <TreeViewDialog  
              onSaveSelection = {(e, selectedsItems) =>  onSaveSelection(e, selectedsItems, fieldId, {id:item.id, type:type  })}
              onClose = {() => onClickEditOperand(item, type)} 
              withCheckBox = {true}
              leafSelection = {true}
              data = {props.formData}
              previousForms = {props.previousForms}
              parentId = {fieldId} type = {props.formData.menu.type.field} />}
          
      </div>
}


const getSeparator = () => {
  return <div style={{  height: "17px", margin:"5px 15px 0px 0px",  borderRight:"2px solid rgb(223, 221, 221)" }} /> 
}

const getConditionItem = (item)=> {
  const firstOperandId = item.firstOperand.id //settings.option + props.formData.actions.condition.type.firstOperand + item.id
  const secondOperandId = item.secondOperand.id //settings.option + props.formData.actions.condition.type.secondOperand + item.id
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, props.formData.actions.condition.type.firstOperand, firstOperandId, "First Operand" )}
        {getSeparator()}
        <div style={{  minWidth: "50px"}} >
        <DropDownListNew
          currentData={props.formData.menu.operator.options}
          minWidth={"30px"}
          initialValue={getDetailValue(item.id, props.formData.actions.condition.type.operator)}
          id={"OperatorList" + item.id}
          onDropDownItemClick={(itemSelected) => onSelectOperator(item.id, itemSelected)}
          onlyLabel={false}
        />
        </div>
        {getSeparator()}
        {getTextRelation(item, props.formData.actions.condition.type.secondOperand, secondOperandId, "Second Operand")}
        
        {<div
          onClick={(e) => onClickDeleteCondition(e, item.id, [firstOperandId,secondOperandId]) } 
          style ={{ paddingLeft: "auto" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const isAuthentificationSetting = ()=> {
  return getCurrentApi().option == props.formData.actions.api.authorization
}

const getSubApiIBodytem = (item)=> {
  const keyId = item.key.id //settings.option + getCurrentApi().option + props.formData.actions.api.type.key + item.id
  const valueId = item.value.id //settings.option + getCurrentApi().option + props.formData.actions.api.type.value + item.id
  return <div key = {item.id} className ="gridLine">
        {getBodyTextRelation(item, props.formData.actions.api.type.key, keyId, "Key", "250px" )}
        {getSeparator()}
        {getBodyTextRelation(item, props.formData.actions.api.type.value, valueId, "Value", "250px")}
      
        {<div
          onClick={(e) => onClickDeleteApiBodySetting(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const getApiItem = (item)=> {
  
  const keyId = item.key.id //settings.option + getCurrentApi().option + props.formData.actions.api.type.key + item.id
  const valueId = item.value.id //settings.option + getCurrentApi().option + props.formData.actions.api.type.value + item.id
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, props.formData.actions.api.type.key, keyId, "Key", {width : isAuthentificationSetting() ? "210px" : "250px", 
          typeData : settings.data && settings.data[settings.option.toLowerCase()].treeDataType} )}
        {getSeparator()}
        {getTextRelation(item, props.formData.actions.api.type.value, valueId, "Value", {width : isAuthentificationSetting() ? "210px" : "250px",
          typeData : settings.data && settings.data[settings.option.toLowerCase()].treeDataType})}
        {isAuthentificationSetting() && getSeparator()}
        {isAuthentificationSetting() && 
          <div style={{  minWidth: "50px"}} >
          <DropDownListNew
            currentData={props.formData.lists.validations.events.api.params}
            minWidth={"50px"}
            initialValue={getDetailApiSettingValue(item.id, props.formData.actions.api.type.destination)}
            id={getCurrentApi().option + item.id}
            onDropDownItemClick={(itemSelected) => onSelectDestination(item.id, itemSelected)}
            onlyLabel={false}
          />
        </div>}
        {<div
          onClick={(e) => onClickDeleteApiSetting(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const getListItem = (item)=> {
  const keyId = item.key.id 
  const valueId = item.value.id 
  
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, props.formData.actions.api.type.key, keyId, isMappingActif() ? "Destination" : "key"
        , {width : isListActif()? "261px" : "252px"
        , parents: isMappingActif() && [...settings.parents.globalId].reverse()
        , ancestorId: isMappingActif() && settings.control.globalId, 
          typeData : settings.data && settings.data[settings.option.toLowerCase()].treeDataType } )}
        {getSeparator()}
        {getTextRelation(item, props.formData.actions.api.type.value, valueId, isMappingActif() ? "Source" : "Value"
        , {width : isListActif()? "261px" : "252px"
        , parents: isMappingActif() && getCurrentOption("mapping").value
        , ancestorId: isMappingActif() && (settings.data.mapping.values ? getCurrentOption("mapping").value.slice(-1)[0] : 0 ),
          typeData : settings.data && settings.data[settings.option.toLowerCase()].treeDataType})}
        {<div
          onClick={(e) => onClickDeleteItem(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const getCustomData = () => {
  return props.process
}

const getTreeItem = (item, marge = 0)=> {
  const keyId = item.key.id 
  const valueId = item.value.id 
  let margeWidth = (10 * marge) + "px"
  return <React.Fragment key = {item.id}>
          <div style = {{ marginLeft: margeWidth, borderBottom: "none" }}  className ="gridLine">
            {getTextRelation(item, props.formData.actions.api.type.key, keyId, "key", {width : "150px"} )}
            {getSeparator()}
            {getTextRelation(item, props.formData.actions.api.type.value, valueId, "Value"
              , {width : "200px", customData:getCustomData(), customTitle:"Select Process"})}       
            {<div style ={{ marginLeft: "auto", marginRight:margeWidth }}>
            <MenuDots  isMenuVisible={true}
              width={menuList.width}
              currentData={menuList.list}
              withoutIcon={true}
              onMenuItemClick={(menuItem) => onMenuItemClick(menuItem, item.id, [keyId, valueId])}/>
            </div>}
          </div> 
          {item.childs.map(child => getTreeItem(child, marge + 1))}
      </React.Fragment>
}

const onMenuItemClick = (menuItem, menuId, lineIds) => {
  switch (menuItem.action.type) {
    case "AddChild":
      onClickAddChildItem(menuId);
      break;
    case "DeleteChild":
      onClickDeleteChildItem(menuId, lineIds);
      break;
  }
};

const deleteNode = (nodes, id) => {
  
  (nodes.details ? nodes.details : nodes.childs).forEach(child => {    
    if (child.id == id) 
      if (nodes.details) 
        nodes.details = nodes.details.filter(item => item.id != child.id)
      else
        nodes.childs = nodes.childs.filter(item => item.id != child.id)
    else 
      deleteNode(child, id)
  })
  
    
}

const onClickDeleteChildItem = (menuId, lineIds) => {
 
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentList = getCurrentOption("tree", settingsData)

  deleteNode(currentList, menuId)
  
  settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
  setSetting(settingsData)
}

const onClickAddItem = (e, type, dataItem) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  var current = getCurrentOption(type, settingsData)
  var keyId = settings.option + props.formData.actions.api.type.key 
  var valueId = settings.option + props.formData.actions.api.type.value 
  dataItem.option = settings.option // a v/rifier l utilit/
  if (isTreeActif()) dataItem["isRoot"] = true
  if (current.details.length > 0) {
    settingsData.data[type].maxDetailsId = settingsData.data[type].maxDetailsId + 1
    settingsData.data[type].detailsId = settingsData.data[type].maxDetailsId 
    dataItem.id = settingsData.data[type].detailsId
    dataItem.key.id = keyId + dataItem.id
    dataItem.value.id = valueId + dataItem.id
    current.details.push(dataItem)
  }
  else {
    settingsData.data[type]["detailsId"] = 0
    settingsData.data[type]["maxDetailsId"] = 0
    dataItem.key.id = keyId + 0
    dataItem.value.id = valueId + 0
    current.details = [dataItem]
 }

  setSetting(settingsData)
}

const onClickAddCondition = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  var current = getCurrentConditions(settingsData)
  var firstOperandId = settings.option + props.formData.actions.condition.type.firstOperand 
  var secondOperandId = settings.option + props.formData.actions.condition.type.secondOperand 
  conditionItem.option = settings.option
  if (current.details.length > 0) {
    settingsData.conditions.maxDetailsId = settingsData.conditions.maxDetailsId + 1
    settingsData.conditions.detailsId = settingsData.conditions.maxDetailsId 
    conditionItem.id = settingsData.conditions.detailsId
    conditionItem.firstOperand.id = firstOperandId + conditionItem.id
    conditionItem.secondOperand.id = secondOperandId + conditionItem.id
    current.details.push(conditionItem)
  }
  else {
    //settingsData["conditions"]["id"] = 0
    settingsData.conditions["detailsId"] = 0
    settingsData.conditions["maxDetailsId"] = 0
    conditionItem.firstOperand.id = firstOperandId + 0
    conditionItem.secondOperand.id = secondOperandId + 0
    current.details = [conditionItem]
 }
  setSetting(settingsData)
}

const onClickDeleteCondition = (e, id, lineIds) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentCondition = getCurrentConditions(settingsData)
  currentCondition.details = currentCondition.details.filter(condition => condition.id != id)
  settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
  
  setSetting(settingsData)
}

const onClickDeleteItem = (e, id, lineIds) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentList = isMappingActif() ? getCurrentOption("mapping", settingsData) : getCurrentOption("list", settingsData)
  currentList.details = currentList.details.filter(current => current.id != id)
  settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
  
  setSetting(settingsData)
}

const onClickAddApiSetting = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var current = getCurrentApi(settingsData)[getCurrentApi().option]
  var keyId = settings.option + getCurrentApi().option + props.formData.actions.api.type.key 
  var valueId = settings.option + getCurrentApi().option + props.formData.actions.api.type.value 
  
  apiSettingItem.option = getCurrentApi().option
  if (current.details.length > 0) {
    getCurrentApi(settingsData)[getCurrentApi().option].maxDetailsId = getCurrentApi(settingsData)[getCurrentApi().option].maxDetailsId + 1
    getCurrentApi(settingsData)[getCurrentApi().option].detailsId = getCurrentApi(settingsData)[getCurrentApi().option].maxDetailsId 
    apiSettingItem.id = getCurrentApi(settingsData)[getCurrentApi().option].detailsId
    apiSettingItem.key.id = keyId + apiSettingItem.id
    apiSettingItem.value.id = valueId + apiSettingItem.id 
    current.details.push(apiSettingItem)
  }
  else {
    getCurrentApi(settingsData)[getCurrentApi().option]["detailsId"] = 0
    getCurrentApi(settingsData)[getCurrentApi().option]["maxDetailsId"] = 0
    apiSettingItem.key.id = keyId + 0
    apiSettingItem.value.id = valueId + 0
    current.details = [apiSettingItem]
 }
  setSetting(settingsData)
}

const onClickDeleteApiSetting = (e, id, lineIds) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentCondition = getCurrentApi(settingsData)[getCurrentApi().option]
  currentCondition.details = currentCondition.details.filter(condition => condition.id != id)
  settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
  setSetting(settingsData)
}

const getBodyOptionValue  = () => {
 return getCurrentApi()[props.formData.actions.api.body].option.replaceAll("-", "")
}
const onClickAddApiBodySetting = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  var current = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()]
  var keyId = settings.option + getCurrentApi().option + getBodyOptionValue() + props.formData.actions.api.type.key 
  var valueId = settings.option + getCurrentApi().option + getBodyOptionValue() + props.formData.actions.api.type.value 
  
  apiSettingItem.option = getBodyOptionValue()
  if (current.details.length > 0) {
    getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].maxDetailsId = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].maxDetailsId + 1
    getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].detailsId = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].maxDetailsId 
    apiSettingItem.id = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()].detailsId
    apiSettingItem.key.id = keyId + apiSettingItem.id
    apiSettingItem.value.id = valueId + apiSettingItem.id 
    current.details.push(apiSettingItem)
  }
  else {
    getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()]["detailsId"] = 0
    getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()]["maxDetailsId"] = 0
    apiSettingItem.key.id = keyId + 0
    apiSettingItem.value.id = valueId + 0
    current.details = [apiSettingItem]
 }
 
  setSetting(settingsData)
}

const onClickDeleteApiBodySetting = (e, id, lineIds) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentCondition = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()]
  currentCondition.details = currentCondition.details.filter(condition => condition.id != id)
  settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
  setSetting(settingsData)
}

const onClickEditOperand = (item, type, e = undefined) => {
  if (e) e.preventDefault();
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  var isOpen = true

  if (isApiActif()) {
    if (isApiBodyDetailsSettings(type)) {
      let currentClickSettings = getCurrentApi(settingsData)[props.formData.actions.api.body][getBodyOptionValue()] 
      isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
      currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
    }

    if (isApiDetailsSettings(type)) {
      
      let currentClickSettings = getCurrentApi(settingsData)[getCurrentApi(settingsData).option] 
      isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
      currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
    }
  }

  if (isConditionsActif()) {
    if (isConditionsDetailsSettings(type)) {
      let currentClickSettings = getCurrentConditions(settingsData)
      isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
      currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
    } else {
      
      isOpen = settingsData.conditions.isClick
      settingsData.conditions.isClick = !isOpen
    }

  }
  
  if (isListActif()) {
   
    if (isListDetailsSettings(type)) {
      let currentClickSettings = getCurrentOption("list", settingsData)
      isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
      currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
    } else {
      
      isOpen = settingsData.data.list.isClick
      settingsData.data.list.isClick = !isOpen
    }

  }

  if (isMappingActif()) {
   
    if (isMappingDetailsSettings(type)) {
      let currentClickSettings = getCurrentOption("mapping", settingsData)
      isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
      currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
    } else {
      
      isOpen = settingsData.data.mapping.isClick
      settingsData.data.mapping.isClick = !isOpen
      
    }

  }

  if (isTreeActif()) {
   
    if (isTreeDetailsSettings(type)) {
      let currentClickSettings = getCurrentOption("tree", settingsData)
      isOpen = getNode(currentClickSettings.details, item.id)[0][type].isClick
      getNode(currentClickSettings.details, item.id)[0][type].isClick = !isOpen
    } else {
      
      isOpen = settingsData.data.tree.isClick
      settingsData.data.tree.isClick = !isOpen
    }

  }
  
  if (isTextActif()) {
    isOpen = settingsData.text.isClick
    settingsData.text.isClick = !isOpen
  }
  setSetting(settingsData)
}

const onClickValid = (e, detail, type, itemToUpdate) => {
  
  if (e) e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
    
    switch (detail.operation) {
      case props.formData.menu.operation.Add:{       
        if (settingsData[type].values) {
          
          settingsData[type].maxId = settingsData[type].maxId + 1
          settingsData[type].id = settingsData[type].maxId 
          itemToUpdate.id = settingsData[type].id
          itemToUpdate.item = detail.value
          
          settingsData[type].values.push(itemToUpdate)
          
        }
        else {
          settingsData[type] = {id : 0, maxId :0}
          //settingsData[type]["maxId"] = 0
          
          itemToUpdate.id = settingsData[type].id
          itemToUpdate.item = detail.value
          settingsData[type].values = [itemToUpdate]
        }
                        
        break;
      }
      case props.formData.menu.operation.Update:{
        settingsData[type].values
        .filter(item => item.id == settingsData[type].id)
        .map(current => current.item = detail.value)
        break;
      }

      case props.formData.menu.operation.Delete:{
        settingsData[type].values = settingsData[type].values
        .filter(item => item.id != settingsData[type].id)    
        if (settingsData[type].values.length>0)   
          settingsData[type].id = settingsData[type].values[0].id
        else
          settingsData[type].values = undefined
        settingsData.errors = []
        break;
      }
    }
   
  setSetting(settingsData)
}




const onClickValidData = (e, detail, type, itemToUpdate) => {
  
  if (e) e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
    
    switch (detail.operation) {
      case props.formData.menu.operation.Add:{       
        if (settingsData.data[type].values) {
          
          settingsData.data[type].maxId = settingsData.data[type].maxId + 1
          settingsData.data[type].id = settingsData.data[type].maxId 
          itemToUpdate.id = settingsData.data[type].id
          itemToUpdate.item = detail.value
          
          settingsData.data[type].values.push(itemToUpdate)
          
        }
        else {
          settingsData.data[type] = {id : 0, maxId :0, treeDataType: settingsData.data[type].treeDataType}
          //settingsData.data[type]["maxId"] = 0
          
          itemToUpdate.id = settingsData.data[type].id
          itemToUpdate.item = detail.value
          settingsData.data[type].values = [itemToUpdate]
        }
                        
        break;
      }
      case props.formData.menu.operation.Update:{
        settingsData.data[type].values
        .filter(item => item.id == settingsData.data[type].id)
        .map(current => current.item = detail.value)
        break;
      }

      case props.formData.menu.operation.Delete:{
        settingsData.data[type].values = settingsData.data[type].values
        .filter(item => item.id != settingsData.data[type].id)    
        if (settingsData.data[type].values.length>0)   
          settingsData.data[type].id = settingsData.data[type].values[0].id
        else
          settingsData.data[type].values = undefined

        settingsData.errors = []
        break;
      }
    }
   
  setSetting(settingsData)
}




const getConditionList = ()=> {

  return settings.conditions.values ? 
    settings.conditions.values.map(condition => { return {id : condition.id, item:condition.item }})
    : []
}

const getList = (type)=> {

  return settings.data[type].values ? 
    settings.data[type].values.map(current => { return {id : current.id, item:current.item }})
    : []
}

const getApiList = ()=> {

  return settings.api.values ? 
    settings.api.values.map(apiItem => { return {id : apiItem.id, item:apiItem.item }})
    : []
}

const isChecked = (current) => {
  return settings.option == current
}
/*
const getExtractionInitial = (responseContent, parentId) => {
  // return { treeViewFormat:"$", treeData:"$", isParentIsArray:Array.isArray(responseContent)}
  return { treeViewFormat:"" + parentId + "", treeData: "" + parentId + "", isParentIsArray:Array.isArray(responseContent)}
}

const getTreeViewData = (data, parentId) => {
  var treeData = []
  var schemaData = []
  
  var responseContent = JSON.parse(JSON.stringify(data))
  convertJsonToTreeData(responseContent, treeData, schemaData, getExtractionInitial(responseContent, parentId))
  return {treeData:treeData, schemaData:schemaData}
  
}
*/
const getApiSubOption  = (currentApi) => {
  
  switch (currentApi.option) {
    case props.formData.actions.api.response:
      return getResponseOption()
    case props.formData.actions.api.schemas:
      return getSchemaOption()
    case props.formData.actions.api.body:
      return getBodyOption()
    default:
      return currentApi[currentApi.option].details.map(item => getApiItem(item))
  }
}

const getApiResponseSubOption  = () => {
  
  switch (getCurrentApi()[props.formData.actions.api.response].option) {
    case props.formData.actions.api.content:
      return getTreeComponent(getCurrentApi()[props.formData.actions.api.response][props.formData.actions.api.content].value, "ResponseContent")
    case props.formData.actions.api.cookies:
      return getTreeComponent(getCurrentApi()[props.formData.actions.api.response][props.formData.actions.api.cookies].value, "ResponseCookies")
  
  }
}



const getApiBodySubOption  = () => {
  let currentApiBodySubOption = getCurrentApi()[props.formData.actions.api.body][getBodyOptionValue()]
  switch (getBodyOptionValue()) {
    case props.formData.actions.api.formdata.replaceAll("-",""):
      return currentApiBodySubOption.details.map(item => getSubApiIBodytem(item))
    case props.formData.actions.api.xwwwformurlencoded.replaceAll("-",""):
      return currentApiBodySubOption.details.map(item => getSubApiIBodytem(item)) 
    case props.formData.actions.api.raw:
      
      return  <RichTextEditor 
                modalType = {props.formData.menu.type.field}
                modalData={props.formData}
                //isInError={isInError(rawEditorId)}
                format={currentApiBodySubOption.format}
                modalParentId={"ApiAuthorization"}
                data={{ id: rawFildId}}
                hideToolBar={true}
                onSaveEdition = {(data) => onSaveEdition(data, rawEditorId)} 
                style ={{ height: "200px",
                  border: isInError(rawEditorId) ? "1px solid rgb(206, 17, 38)" : "1px solid gray"
                }} 
                /> 
              
  
  }
}


const getApiSchemaSubOption  = () => {
  
  switch (getCurrentApi()[props.formData.actions.api.schemas].option) {
    case props.formData.actions.api.content:
      return getTreeComponent(getCurrentApi()[props.formData.actions.api.schemas][props.formData.actions.api.content].value, "SchemaContent")
    case props.formData.actions.api.cookies:
      return getTreeComponent(getCurrentApi()[props.formData.actions.api.schemas][props.formData.actions.api.cookies].value, "SchemaCookies")
  
  }
}


const getBodyOption = () => {
  let bodyId = "BodyOption"
  return (
    <React.Fragment>
      <div id ={bodyId} className ="gridInnerLine">
        <div className="modal-line">
          {props.formData.lists.validations.events.api.body.options.map((item, index) => getApiBodyParams(item, index))}
        </div>   
        
        {iskeyBased(getBodyOptionValue()) ? <div  
          onClick={(e) => onClickAddApiBodySetting(e) } 
          style ={{ marginLeft: "auto", paddingRight:"3px" }}>
          <AddCommand className ="hoverGreen"/>
        </div> :
        <div  style ={{ marginLeft: "auto", marginTop: "5px"}}>
          <DropDownListNew
            currentData={props.formData.lists.validations.events.api.rawTypes}
            minWidth={"30px"}
            initialValue={getCurrentApi()[getCurrentApi().option].type ? getCurrentApi()[getCurrentApi().option].type : "Text"}
            id={"RawTypeList"}
            onDropDownItemClick={(itemSelected) => onSelectRawType(itemSelected)}
            onlyLabel={false}/>
        </div>
        
      }
        
      </div>
      {getCurrentApi()[props.formData.actions.api.body] && getApiBodySubOption()}
      
  </React.Fragment>)
}

const getResponseOption = () => {
  return (
    <div id ="ResponseOption">
      <div className="modal-line">
          {props.formData.lists.validations.events.api.response.options.map((item, index) => getApiResponseParams(item, index))}
      </div>
      <div >
        {getCurrentApi()[props.formData.actions.api.response] && getApiResponseSubOption()}
      </div>
  </div>)
}

const getSchemaOption = () => {
  return (
    <div id ="SchemaOption">
      <div className="modal-line">
        {props.formData.lists.validations.events.api.schemas.options.map((item, index) => getApiSchemaParams(item, index))}
      </div>
      <div >
        {getCurrentApi()[props.formData.actions.api.schemas] && getApiSchemaSubOption()}
      </div>
  </div>)
}

/*
const convertJsonToTreeData = (jsonResponse, treeViewFormat=[], structData =[], parentId) => {
  //, parentId = { treeViewFormat:parentId, treeData:parentId, isParentIsArray:undefined}) => {
  
  Object.entries(jsonResponse).map(([menu, value], index) => {
    
    if (typeof value === 'object') {
      
      let nTreeViewFormat = treeViewFormat.length
      let nTreeData = structData.length
      var isArray = Array.isArray(value)
      
      let newTreeViewFormatId = parentId.treeViewFormat + "_" + index 
      
      if (isArray) {
        treeViewFormat.push({id:newTreeViewFormatId , item:`"${menu}":array`, childs:[]}) //[]  
        
      }      
      else {
        
        treeViewFormat.push({id:newTreeViewFormatId , item:`"${menu}":object`, childs:[]})
        
      }
     
      let newTreeDataId = parentId.treeData + "_" + index 
      if (isArray) {// parentId.structDataId != parentId.treeData //(prevTreeDataParentId != parentId.treeData) {
        
        //if (true) {
          parentId.structDataId = parentId.treeData
          structData.push({id:newTreeDataId, parentId:parentId.treeData, item:`"${menu}":array`, childs:[]})
        
          convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,structData[nTreeData].childs, 
            { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:true})
        //} else {
         // convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs
           // , treeData[menu],structData, 
            //{ treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData})
          
        //}
      }
      else {
        if (!parentId.isParentIsArray || index == 0) {
          parentId.structDataId = parentId.treeData
          structData.push({id:newTreeDataId, parentId:parentId.treeData, item:`"${menu}":${typeof value}`, childs:[]})
          convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs
            ,structData[nTreeData].childs, 
            { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:false})
            // { treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData, isParentIsArray:false})
        } else {
          
          convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs
            ,structData, 
           // { treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData, isParentIsArray:true})
           { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:true})
        }
        
        
      }
    }
    else {
      treeViewFormat.push({id:parentId.treeViewFormat + "_" + index,  item:`"${menu}":${value}`, childs:[]})
      if (!parentId.isParentIsArray) {

        if (!structData.map(data => data.item).includes(menu)) 
          structData.push({id:parentId.treeData + "_" + structData.length,parentId:parentId.treeData,  item:`"${menu}":${typeof value}`, childs:[]})
      }
    }           
  })
 // treeIdIndex = treeIdIndex + 1
  
};
*/


const getApiOption = () => {
  const currentApi = getCurrentApi()

  
  return (
    <React.Fragment>
      {getApiConfig(currentApi, "200px")}
      {currentApi.option ? 
      <React.Fragment>
        <div className ="gridInnerLine" >
          <div style ={{ width: "65px" }}>
            <EditableDropDownList
              id="MethodList"
              title=""
              initialValue={currentApi ? currentApi.method :"GET" }
              currentData={props.formData.lists.validations.events.api.methods}
              policy={{canAdd : false, canEdit : false, canDelete : false }}
              type = {props.formData.menu.type.field}
              onDropDownItemClick={(itemSelected) => onSelectMethod(itemSelected)}
              width = "80px"
              style = {{fontFamily : "Arial", fontSize : "14px", fontWeight : "bold", color : "gray" }}
              onClickValid={(e, detail) => {}}/>
          </div>
          <div>
            {getApiUrl("503px")}
          </div>
      </div>   
     
      <div className ="gridInnerLine" >
        {apiSettings.options.length > 1 && 
          <div className="modal-line">
            {apiSettings.options.map((item, index) => getApiParams(item, index))}
          </div>
        }
     
        {  iskeyBased(currentApi.option)  && <div  
          onClick={(e) => onClickAddApiSetting(e) } 
          style ={{ marginLeft: "auto", paddingRight:"3px", marginTop:"5px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        { currentApi[currentApi.option] && getApiSubOption(currentApi)}
      </div>
      </React.Fragment>:null}

  </React.Fragment>)
}

const getConditionOption = () => {
  const currentCondition = settings.conditions.values ? getCurrentConditions(): undefined
  return (
    <React.Fragment>
      <div className ="gridHeadLine" >
        <div style ={{ width: "245px" }}>
          <EditableDropDownList
            id="ConditionList"
            title="if:"
            initialValue={currentCondition ? currentCondition.item: ""}
            currentData={getConditionList()}
            policy={{canAdd : true, canEdit : settings.conditions.values != undefined, canDelete : settings.conditions.values != undefined }}
            type = {props.formData.menu.type.field}
            onDropDownItemClick={(itemSelected) => onSelect(itemSelected, "conditions")}
            style = {{ }}
            width = "100px"
            onClickValid={(e, detail) => onClickValid(e, detail, "conditions", sample)}
            />
        </div>
          {(!props.data || props.data.return.isVisible ) && getSeparator()}
        <div>
          { props.data && props.data.return.type == "List" ?
            props.data.return.isVisible && getListOption(props.data.return.data, currentCondition ? currentCondition.value : settings.conditions.value, {width : "225px", label : "Decision:", readOnly :false}) 
          :
            getTextOption(props.formData.actions.option.condition, currentCondition ? currentCondition.value : settings.conditions.value, {width : "225px", label : "Return:", readOnly :false})}
        </div>
        {settings.conditions.values &&<div  
          onClick={(e) => onClickAddCondition(e) } 
          style ={{ marginLeft: "auto", paddingRight:"3px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        {getCurrentConditions().details.map(item => getConditionItem(item))}
      </div>

  </React.Fragment>)
}

const getTreeOption = (type) => {
  const currentOption = settings.data[type].values ? getCurrentOption(type): undefined
  return (
    <React.Fragment>
      <div className ="gridHeadLine" >
        <div style ={{ width: "300px" }}>
          <EditableDropDownList
            id={type + "List"}
            title="Name:"
            initialValue={currentOption ? currentOption.item: ""}
            currentData={getList(type)}
            policy={{canAdd : true, canEdit : settings.data[type].values != undefined, canDelete : settings.data[type].values != undefined }}
            type = {props.formData.menu.type.field}
            onDropDownItemClick={(itemSelected) => onSelectData(itemSelected, type)}
            style = {{ }}
            width = "150px"
            onClickValid={(e, detail) => onClickValidData(e, detail, type, sample)}/>
        </div>
        {settings.data[type].values &&<div  
          onClick={(e) => onClickAddItem(e, type, treeItem) } 
          style ={{ marginLeft: "auto", paddingRight:"3px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        {getCurrentOption(type).details.map(item => getTreeItem(item))}
      </div>

  </React.Fragment>)
}

const getNode = (nodes, parentId) => {

  let node = nodes.map(child => {
    if (child.id == parentId)
      return child
    else
      return getNode(child.childs, parentId)
  })
  
  return node.flat(Infinity)
}

const onClickAddChildItem = (parentId) => {
 
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  var current = getCurrentOption("tree", settingsData)
  var keyId = settings.option + props.formData.actions.api.type.key 
  var valueId = settings.option + props.formData.actions.api.type.value 
  treeItem.option = settings.option
  
  settingsData.data.tree.maxDetailsId = settingsData.data.tree.maxDetailsId + 1
  settingsData.data.tree.detailsId = settingsData.data.tree.maxDetailsId 
  treeItem.id = settingsData.data.tree.detailsId
  treeItem.key.id = keyId + treeItem.id
  treeItem.value.id = valueId + treeItem.id
  var parentNode = getNode(current.details, parentId)[0]
 
  treeItem["parent"]=  {id:parentNode.id, item:parentNode.value.value}
  parentNode.childs.push(treeItem)
  
  setSetting(settingsData)
}

const getOption = (type) => {
  const currentOption = settings.data[type].values ? getCurrentOption(type): undefined
  
  return (
    <React.Fragment>
      <div className ="gridHeadLine" >
        <div style ={{ width: "245px" }}>
          <EditableDropDownList
            id={type + "List"}
            title="Name:"
            initialValue={currentOption ? currentOption.item: ""}
            currentData={getList(type)}
            policy={{canAdd : true, canEdit : settings.data[type].values != undefined, canDelete : settings.data[type].values != undefined }}
            type = {props.formData.menu.type.field}
            onDropDownItemClick={(itemSelected) => onSelectData(itemSelected, type)}
            style = {{ }}
            width = "150px"
            onClickValid={(e, detail) => onClickValidData(e, detail, type, sample)}
            />
        </div>
        {isMappingActif() && getSeparator()}
        {isMappingActif() && getTextOption(props.formData.actions.option.mapping, currentOption 
            ? currentOption.value : settings.data.mapping.value, {width : "225px", label : "Data:", readOnly:true}
            , true)}
        
        {settings.data[type].values &&<div  
          onClick={(e) => onClickAddItem(e, type, listSettingItem) } 
          style ={{ marginLeft: "auto", paddingRight:"3px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        {getCurrentOption(type).details.map(item => getListItem(item))}
      </div>

  </React.Fragment>)
}
/*
 Name: <input
            className="textBoxWithoutBorder"
            value={getCurrentApi().name? getCurrentApi().name : ""}
            onKeyPress={(e) => fireEventKeyPress(e, {id : fieldId},props.formData.actions.event.type.onkeyPress) }
            onBlur={(e) => fireOtherEvent(e, {id : fieldId},props.formData.actions.event.type.onBlur) }
            onChange={(e) => changeValue(e.target.value, fieldId, "name") }
            style={{width: width, marginLeft: "20px", marginRight: "5px"}}/>
*/
const getApiConfig = (currentApi, width = "100%") => {
  const fieldId = settings.option + "ConfigValue"
  //const currentApi = getCurrentApi().values ? getCurrentApi(): undefined
  return <div id={settings.option + "ConfigValue"} style={{  display: "flex", marginBottom: "5px", marginLeft: "5px", marginRight: "5px"}} >
            <div style ={{ width: "245px" }}>
              <EditableDropDownList
                id="ApiList"
                title="Name:"
                initialValue={currentApi ? currentApi.item: ""}
                currentData={getApiList()}
                policy={{canAdd : true, canEdit : getCurrentApi().option != undefined, canDelete : getCurrentApi().option != undefined }}
                type = {props.formData.menu.type.field}
                onDropDownItemClick={(itemSelected) => onSelect(itemSelected, "api")}
                width = "200px"
                style = {{ }}
                onClickValid={(e, detail) => onClickValid(e, detail, "api", apiSample)}/>
            </div>
            {getSeparator()}

            <span style ={{ marginTop: "3px" }} >Call:</span>
            { 
            
            <div style ={{ marginTop: "2px", width: "300px" }}>
            <EditableDropDownList
              id="ApiCallList"
              title=""
              initialValue={getCurrentApi().callType ? getCurrentApi().callType :"SYNC" }
              currentData={props.formData.lists.validations.events.api.callTypes}
              policy={{canAdd : false, canEdit : false, canDelete : false }}
              type = {props.formData.menu.type.field}
              onDropDownItemClick={(itemSelected) => onSelectCallType(itemSelected)}
              width = "80px"
              style = {{fontFamily : "Arial", marginLeft: "10px", fontSize : "14px", fontWeight : "bold", color : "gray" }}
              onClickValid={(e, detail) => {}}/>
            </div>}
        </div>
}

const getTextOptionValue = (inputValue) => {
  const value = Array.isArray(inputValue) ? getValueFromArray(inputValue).name :inputValue
  return value ? value : ""
}

const getTextOption = (type, inputValue, option = {width : "100%", label : "Return:", readOnly:false}) => {
  
  const fieldId = settings.option + "TextValue"
  return <div style={{  display: "flex", marginRight: "5px"}} >
          <div id={settings.option + "TextValue"} >
            <span style ={{ color:"gray", marginTop: "4px", marginRight: "5px", fontSize:"14px", fontWeight:"bold", fontFamily:"sans-serif" }}>{option.label}</span>
          </div>
       <input
        className="textBoxWithoutBorder"
        readOnly= {option.readOnly }
        value={getTextOptionValue(inputValue)}
        onKeyPress={(e) => fireEventKeyPress(e, {id : fieldId}, props.formData.actions.event.type.onkeyPress) }
        onBlur={(e) => fireOtherEvent(e, {id : fieldId}, props.formData.actions.event.type.onBlur) }
        onChange={(e) => changeValue(e.target.value, fieldId) }
        style={{width: option.width, marginLeft: "5px" 
        , border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}/>
      {(isMappingActif() || isPropertiesText) && <div onClick={(e) => onClickEditOperand(undefined, type, e) } >
        {getCommandIcon(type, isMappingActif() ? settings.data[type.toLowerCase()].isClick : settings[type.toLowerCase()].isClick)}
      </div>}
      {(isMappingActif() ? settings.data[type.toLowerCase()].isClick : settings[type.toLowerCase()].isClick) && <TreeViewDialog  
        onSaveSelection = {(e, selectedsItems) =>  onSaveSelection(e, selectedsItems, fieldId)}
        onClose = {() => onClickEditOperand(undefined, type)} 
        withCheckBox = {true}
        leafSelection = {!isMappingActif()}
        data = {props.formData}
        previousForms = {props.previousForms}
        parentId = {fieldId} type = {props.formData.menu.type.field} />}
  </div>
}

const getListOption = (data, inputValue, option = {width : "100%", label : "Return:", readOnly:false}) => {
  
  const fieldId = settings.option + "ReturnListValue"
  return <div   id={fieldId}  style={{  display: "flex", marginRight: "5px"}} >
            <div>
              <span style ={{ color:"gray", marginTop: "4px", marginRight: "5px", fontSize:"14px", fontWeight:"bold", fontFamily:"sans-serif" }}>{option.label}</span>
            </div>
            <div  style={{ marginTop: "-4px"}} >
              <DropDownListNew
                currentData={data}
                minWidth={"30px"}
                initialValue={inputValue && inputValue.item}
                id={"ReturnList"}
                onDropDownItemClick={(itemSelected) => changeValue(itemSelected, fieldId)}
                onlyLabel={false}
              />
            </div>
     
  </div>
}

const iskeyBased = (option) => {
  return ![props.formData.actions.api.body, props.formData.actions.api.response
    , props.formData.actions.api.schemas,, props.formData.actions.api.raw].includes(option)
}

const onChangeOption = (option) => {
  
  setSetting({...settings, option:option})
}

const getOptionRadio = (optionText, index, isMultipleChoice) => {
  return <div key={index} className="modal-list">
          {isMultipleChoice && <div style={{ paddingTop: "2px"}}>
            <RadioIcon checked={isChecked(optionText)}
            click={() => onChangeOption(optionText)} />
          </div>}
          <div style={{marginRight: "20px"}}>
            {optionText}
          </div> 
        </div>
}

const setApiMethod = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  switch (optionValue) {
    case props.formData.actions.api.response:   
      if (!getCurrentApi(settingsData)[optionValue]) 
        getCurrentApi(settingsData)[optionValue] = {option:props.formData.actions.api.content
          , [props.formData.actions.api.content]: {value:[]}
          , [props.formData.actions.api.cookies]: {value:[]}
        }
     
      break;
    case props.formData.actions.api.schemas:
      if (!getCurrentApi(settingsData)[optionValue]) 
        getCurrentApi(settingsData)[optionValue] = {option:props.formData.actions.api.content
          , [props.formData.actions.api.content]: {value:[]}
          , [props.formData.actions.api.cookies]: {value:[]}
        }
      break;
    case props.formData.actions.api.body:
     
      if (!getCurrentApi(settingsData)[optionValue]) 
        getCurrentApi(settingsData)[optionValue] = {option:props.formData.actions.api.raw
          , [props.formData.actions.api.raw]: {value:[]}
          , [props.formData.actions.api.formdata.replaceAll("-","")]: {value:[], details:[] }
          , [props.formData.actions.api.xwwwformurlencoded.replaceAll("-","")]: {value:"", details:[] }
        }
        
      break;
    default:
      if (!getCurrentApi(settingsData)[optionValue]) getCurrentApi(settingsData)[optionValue] = {details:[]}
      
      break;
     
  }
  getCurrentApi(settingsData).option =optionValue
  
  setSetting(settingsData)

}


const setBodyMethod = (optionValue) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentApi(settingsData)[props.formData.actions.api.body].option =optionValue
  setSetting(settingsData)
}

const setResponseMethod = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentApi(settingsData)[props.formData.actions.api.response].option =optionValue
  setSetting(settingsData)
}

const setSchemaMethod = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentApi(settingsData)[props.formData.actions.api.schemas].option =optionValue
  setSetting(settingsData)
}
const getApiParams = (optionText, index) => {
  return <div id = {"Api" +optionText} key={"Api" +index} className="modal-list" onClick={() => setApiMethod(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  borderBottom: optionText == getCurrentApi().option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const getApiBodyParams = (optionText, index) => {
  
  return <div key={index} className="modal-list">
          <div style={{ paddingTop: "2px"}}>
            <RadioIcon checked={getBodyOptionValue() ==optionText.replaceAll("-","")}
              click={() => setBodyMethod(optionText.replaceAll("-",""))} />
          </div>
          <div style={{marginRight: "20px"}}>
            {optionText}
          </div> 
        </div>
}

const getApiResponseParams = (optionText, index) => {
  return <div key={"ApiResponse" + index} className="modal-list" onClick={() => setResponseMethod(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none", 
           borderBottom: optionText == getCurrentApi()[props.formData.actions.api.response].option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const getApiSchemaParams = (optionText, index) => {
  return <div key={"ApiSchema" + index} className="modal-list" onClick={() => setSchemaMethod(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  
          borderBottom: optionText == getCurrentApi()[props.formData.actions.api.schemas].option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const isTextActif  = () => {
  return settings.option == props.formData.actions.option.text 
}

const isApiSubOption  = (optionTocheck) => {
  return optionTocheck == props.formData.actions.api.params 
      || optionTocheck == props.formData.actions.api.authorization
      || optionTocheck == props.formData.actions.api.headers
      || optionTocheck == props.formData.actions.api.body
      || optionTocheck == props.formData.actions.api.response
      || optionTocheck == props.formData.actions.api.schemas
}

const isApiBodySubOption  = (optionTocheck) => {
  return optionTocheck == props.formData.actions.api.raw.replaceAll("-", "")
      || optionTocheck == props.formData.actions.api.formdata.replaceAll("-", "")
      || optionTocheck == props.formData.actions.api.xwwwformurlencoded.replaceAll("-", "")
      
}

const isApiActif  = (optionTocheck = settings.option) => {
  return optionTocheck == props.formData.actions.option.api 
}

const isApiBodyActif  = () => {
  return getCurrentApi().option == props.formData.actions.api.body 
}


const isConditionsActif  = () => {
  return settings.option == props.formData.actions.option.condition 
}

const isListActif  = () => {
  return settings.option == props.formData.actions.option.list 
}

const isTreeActif  = () => {
  return settings.option == props.formData.actions.option.tree 
}

const isMappingActif  = () => {
  return settings.option == props.formData.actions.option.mapping 
}
const onError = settings.errors.length > 0

const onSelect = (itemSelected, type) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  settingsData[type].id = itemSelected.id
  setSetting(settingsData)
}

const onSelectData = (itemSelected, type) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  settingsData.data[type].id = itemSelected.id
  setSetting(settingsData)
}

/*const onSelectApi = (itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  settingsData.api.id = itemSelected.id
  setSetting(settingsData)
}*/



const onSelectMethod = (itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentApi(settingsData).method =itemSelected.item
    
  setSetting(settingsData)
}

const onSelectCallType = (itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  getCurrentApi(settingsData).callType =itemSelected.item
    
  setSetting(settingsData)
}

const onSelectRawType = (itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
    
  getCurrentApi(settingsData)[getCurrentApi(settingsData).option]["type"] = itemSelected.item
  
  setSetting(settingsData)
}

const onSaveEdition = (format, fieldId) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  var optionRaw = getCurrentApi(settingsData)[getCurrentApi(settingsData).option][getBodyOptionValue()]
  optionRaw["value"] = format.itemValue.textContent
  optionRaw["format"] = format
  optionRaw["fieldId"] = fieldId
  
  if (format.itemValue.checkedDetail != null) {
    if (optionRaw.checkedDetail)
      optionRaw["checkedDetail"] = [...optionRaw.checkedDetail, format.itemValue.checkedDetail]
    else
      optionRaw["checkedDetail"] = [format.itemValue.checkedDetail]
  }
  settingsData.errors = settingsData.errors.filter(error => error.id != fieldId )
  
  setSetting(settingsData)
}

const onSelectOperator = (id, itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentConditions(settingsData).details.filter(item => item.id == id)[0]
        [props.formData.actions.condition.type.operator].value = itemSelected.item;
        
  setSetting(settingsData)
}

const onSelectDestination = (id, itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentApi(settingsData)[getCurrentApi(settingsData).option].details.filter(item => item.id == id)[0]
        [props.formData.actions.api.type.destination].value = itemSelected.item;
        
  setSetting(settingsData)
}


return props.isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay" />
          <div
            className="modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal">
              <div className="modal-line">    
                <div className="header-left">
                {getTitle() }
                </div>        
                <div className="header-right">
                  <CloseCommand onClick={props.hide} />
                </div>
              </div>  
              <div>
                {<div className="modal-line">
                  {currentSetting.options.map((item, index) => getOptionRadio(item, index, currentSetting.options.length > 1))}
                 </div>}
                {getOptionForm(settings.option)}
              </div>
              
              <div className="modal-line-right">
                <div onClick={props.hide} >
                  <input style ={{ border: "1px solid lightGray", backgroundColor: "white", fontSize:"12px", color : "lightGray"
                  , height: "20px", padding: "0px", width: "70px", }} type="button" className="button" value="Cancel"/>
                </div>
                <div onClick ={() => !onError && fireEventOnSaveValue()}>
                  <input style ={{ backgroundColor: onError  ? "lightGray" : "#008dff",  fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} 
                  type="button" className="button" value="Save"/>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
  }

